import { OdataManager } from '@/api/odata/odata-manager';
import { DrawingPackageIteration } from '@/api/model/interfaces';

export default class DrawingPackageIterationOdata extends OdataManager<DrawingPackageIteration> {}
